// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__2IphH","ghost":"Tooltip_ghost__2cRSP","align":"Tooltip_align__1BfWW","ttooltip":"Tooltip_ttooltip__PKq0t"};